import React, { useState, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { BASE_API } from '../../api/Globals';
import Menu from '../../components/sturtural/Menu';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { helpHttp } from '../../helpers/helpHttp';
import { Toast } from 'primereact/toast';
import { storage } from '../../helpers/storage';

const estatus = [
    { label: 'Todos', value: 0 },
    { label: 'Pendientes', value: 1 },
/*     { label: 'Entregado completo', value: 4 },
 */    { label: 'Entregado parcial', value: 6 },
];

const getReporte = [
    { label: 'General', value: 1 },
    { label: 'Por nivel', value: 2 },
    { label: 'Por CT', value: 3 },
];

const getEntrega = [
    { name: 'Focalizado', code: 1 },
    { name: 'Sede', code: 2 },
]

const initForm = {
    tipoReporte: getReporte[0].value,
    municipio: null,
    localidad: null,
    nivel: null,
    tipoEntrega: getEntrega[0],
    ct: '',
    estado: estatus[0].value
}


const ReporteExistenciaInventario = () => {
    const navigate = useNavigate();
    const [municipios, setMunicipios] = useState([]);
    // const [getReporte, setGetReporte] = useState([]);
    const [getLocalidad, setGetLocalidad] = useState([]);
    const [getNivel, setGetNivel] = useState([]);
    // const [getUniverso, setGetUniverso] = useState([]);
    // const [municipio, setMunicipio] = useState(null);
    // const [ct, setCt] = useState('');
    // const [estado, setEstado] = useState(estatus[0].value)
    const [form, setForm] = useState(initForm)
    const [loading, setLoading] = useState(false);
    const [loadingInv, setLoadingInv] = useState(false);
    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);
    const perfil = storage.get('perfilid');
    const ciclo = storage.get('ciclo');
    const toast = useRef(null);


    useEffect(() => {
        if (![1, 5, 3, 19].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        async function obtenerDrops() {
            const resMuni = await helpHttp().post(`${BASE_API}Escuela/CargarMunicipios`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                const todos = { IdMunicipio: 0, Municipio: 'Todos' }
                res.unshift(todos);
                setMunicipios(res);
                return res
                // getLocalidades(res[0]);
            })

            const resNivel = await helpHttp().get(`${BASE_API}BusquedaAlumnos/GetRptNivel`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                const todos = { code: 0, name: 'Todos' }
                res.ITEMS.ITEMS.unshift(todos);
                setGetNivel(res.ITEMS.ITEMS);
                return res.ITEMS.ITEMS;
            })
            getLocalidades(resMuni[0], resNivel[0])
        }
        obtenerDrops()
    }, [])

    const handlerRedirect = () => {
        setAviso(false);
    }

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'municipio':
                getLocalidades(value, form.nivel);
                break;
            default:
                setForm({
                    ...form,
                    [name]: value,
                })
                break;
        }
    }

    const getLocalidades = (municipio, nivel) => {
        if (municipio.IdMunicipio !== 0) {
            helpHttp().post(`${BASE_API}Escuela/CargarLocalidades/${municipio.IdMunicipio}`, {
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.length > 0) {
                    [1].includes(parseInt(perfil)) && res.unshift({
                        IdLocalidad: 0,
                        Localidad: 'Todos'
                    })
                    setGetLocalidad(res)
                    setForm({
                        ...form,
                        nivel: nivel,
                        municipio: municipio,
                        localidad: res[0]
                    });
                }
            })
        } else {
            let item = [{ IdLocalidad: 0, Localidad: 'Todos' }];
            setGetLocalidad(item);
            setForm({
                ...form,
                nivel: nivel,
                municipio: municipio,
                localidad: item[0]
            })
        }
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            // console.log(module)
            // if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });

            module.saveAs(data, fileName + EXCEL_EXTENSION);
            // }
        });
        setLoading(false)
    };

    const ActualizarInventario = () => {
        setLoadingInv(true)
        helpHttp().post(`${BASE_API}Reportes/postActualizarReporte`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: res.MESSAGE, life: 5000 });
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: '', life: 5000 });
            }
            setLoadingInv(false);
        })
    }

    const GenerarReporte = () => {
        setLoading(true);

        if (form.municipio !== null) {
            helpHttp().post(`${BASE_API}Prendas/SpdRptExistencia`, {
                body: {
                    Opcion: 1,
                    CT: form.ct.trim(),
                    IdMunicipio: form.municipio.IdMunicipio,
                    parametrosExtras: `[{
                        "IdCicloEscolar": ${ciclo.IdCicloEscolar},
                        "IdLocalidad": ${form.localidad.IdLocalidad},
                        "IdNivel": ${form.nivel.code},
                        "IdStatus": ${form.estado},
                        "TipoEntrega": ${form.tipoEntrega.code}
                    }]`
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    if (res.ITEMS.length > 0) {
                        general(res.ITEMS);
                    } else {
                        toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'No se puede generar maquila, no hay alumnos a entregar.', life: 5000 })
                        setLoading(false);
                    }
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Error de conexión, intente de nuevo.', life: 5000 })
                    setLoading(false);
                }
            })
        }
    }

    const general = (contenido) => {
        import('xlsx-js-style').then((xlsx) => {
            const worksheet1 = xlsx.utils.json_to_sheet(contenido, { origin: 'A4' });
            const arrCol = Object.keys(contenido[0]).map((i, num) => `${(num + 10).toString(36).toUpperCase()}4`)
            worksheet1['!cols'] = []
            for (const item of arrCol) {
                worksheet1[item].s = { alignment: { wrapText: true }, fill: { fgColor: { rgb: "7A7A7A" } }, font: { color: { rgb: "FFFFFF" } } }
                worksheet1['!cols'].push({ 'width': 15 })
            }
            const text1 = `Proceso de entrega de uniformes gratuitos ciclo ${ciclo.Descripcion}`;
            const text2 = 'Requerimientos de prendas por municipio';
            const text3 = `Municipio: ${form.municipio.Municipio}`;
            const workbook = {
                Sheets: {
                    [form.municipio.Municipio]: {
                        A1: { t: 's', v: text1, s: { alignment: { horizontal: "center" }, font: { bold: true, sz: '14' } } },
                        A2: { t: 's', v: text2, s: { alignment: { horizontal: "center" }, font: { bold: true, sz: '14' } } },
                        A3: { t: 's', v: text3, s: { alignment: { horizontal: "center" }, font: { bold: true, sz: '11' } } },
                        "!merges": [
                            { s: { r: 0, c: 0 }, e: { r: 0, c: arrCol.length - 1 } }, /* A1:A2 */
                            { s: { r: 1, c: 0 }, e: { r: 1, c: arrCol.length - 1 } }, /* A1:A2 */
                            { s: { r: 2, c: 0 }, e: { r: 2, c: arrCol.length - 1 } }, /* A1:A2 */
                        ],
                        ...worksheet1
                    }
                }, SheetNames: [`${form.municipio.Municipio}`],
            };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            saveAsExcelFile(excelBuffer, `ReporteRequerimientoPrendas_${form.municipio.Municipio}_${new Date().toLocaleDateString('en-GB')}_${ciclo.Descripcion}`);
        });
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button-primary" />;

    return (
        <>
            <Menu link='reporte-general' />
            <Toast ref={toast} />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h3>Reporte requerimientos de prendas</h3>
                        <div className="p-fluid formgrid grid">
                            {/* <div className="field col-12 md:col-4">
                                <label htmlFor="tipoRreporte">Tipo de reporte:</label>
                                <Dropdown id="tipoReporte" value={form.tipoReporte} options={getReporte} name="tipoReporte" placeholder="Elige un reporte" onChange={handleOnChange} />
                            </div> */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="municipio">Municipio:</label>
                                <Dropdown id="municipio" value={form.municipio} options={municipios} name="municipio" optionLabel="Municipio" placeholder="Elige un municipio" filter onChange={handleOnChange} />
                            </div>
                            {/* <div className="field col-12 md:col-4">
                                <label htmlFor="localidad">Localidad:</label>
                                <Dropdown id="localidad" value={form.localidad} options={getLocalidad} optionLabel='Localidad' name="localidad" placeholder="Elige una localidad" filter onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="nivel">Nivel:</label>
                                <Dropdown id="nivel" value={form.nivel} options={getNivel} optionLabel='name' name="nivel" placeholder="Elige un nivel" onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="tipoEntrega">Tipo de entrega:</label>
                                <Dropdown id="tipoEntrega" value={form.tipoEntrega} optionLabel='name' options={getEntrega} name="tipoEntrega" placeholder="Elige un tipo de entrega" onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="ct">Clave CT:</label>
                                <InputText value={form.ct} id="ct" name="ct" type="text" placeholder='Todos' onChange={handleOnChange} />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="estado">Estatus:</label>
                                <Dropdown id="estado" value={form.estado} options={estatus} name="estado" optionLabel="label" optionValue='value' onChange={handleOnChange} />
                            </div> */}
                        </div>
                        <div className="p-dialog-footer">
                            <div className="border-top-1 surface-border pt-3 text-right">
                                <Button className="hidden p-button p-component p-button-outlined mr-3" type='button' label="Actualizar inventario" name="button-generar" disabled={loadingInv} icon={(loadingInv ? 'pi pi-spin pi-spinner' : 'pi pi-refresh')} onClick={() => ActualizarInventario()} />
                                <Button type='button' label="Generar" name="button-generar" id="button-generar" disabled={loading} style={{ marginRight: '1%' }} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel')} onClick={() => GenerarReporte()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog header="Aviso" draggable={false} closable={false} visible={aviso} onHide={() => setMessage(false)} style={{ width: '400px' }} modal className="p-fluid" footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>
        </>
    )
}

export default ReporteExistenciaInventario;